import { panelSnapshotPosts } from './PanelSnapshotPosts';

const runOfShowSnapshot = {
    id: 'cGFuZWw6NWRhZjhjNzEzNWJmMjcxNjI0NTZlMmRh',
    partnerId: 1436,
    clientId: 8033,
    name: 'Run of Show',
    description: '',
    publishTier: 'TWO',
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: null,
                contrast: null,
            },
        },
    },
    storyboard: {
        id: 'c3Rvcnlib2FyZDo1ZGFmOGM3MTM1YmYyNzE2MjQ1NmUyZDg=',
        name: 'legz - run of show',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
    },
    scene: {
        id: 'c2NlbmU6NWRhZjhjNzEzNWJmMjcxNjI0NTZlMmQ5',
        name: 'Scene 1',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                children: null,
                id: '1',
                name: 'Run of Show',
                type: 'runOfShow',
                css: null,
                js: null,
                options: {
                    player: {
                        playing: true,
                        duration: 6,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    labelTimeZone: '',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: true,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {
                        userGroup: {
                            default: 'p-reset p-0 pb-1',
                        },
                        postText: {
                            default: 'p-reset p-0 pt-1',
                        },
                        metaGroup: {
                            default: 'p-reset p-0 pt-1',
                        },
                        lineClampVerticalAlign: {
                            default: 'top',
                        },
                        extraPostData: {
                            default: 'p-reset p-0 pt-1',
                        },
                        postInner: {
                            default: 'p-reset p-2',
                        },
                    },
                    postVersion: 2,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    showImageStyles: true,
                    imageFiltersOpen: true,
                    imageFilterBlur: false,
                    imageFilterBrightness: false,
                    imageFilterContrast: false,
                    imageFilterGrayscale: false,
                    imageFilterSaturate: false,
                    imageFilterHueRotate: false,
                    imageFilterOpacity: false,
                    imageFilterInvert: false,
                    imageFilterSepia: false,
                    imageFilterBlurValue: 0,
                    imageFilterBrightnessValue: 100,
                    imageFilterContrastValue: 100,
                    imageFilterGrayscaleValue: 0,
                    imageFilterSaturateValue: 100,
                    imageFilterHueRotateValue: 0,
                    imageFilterOpacityValue: 100,
                    imageFilterInvertValue: 0,
                    imageFilterSepiaValue: 0,
                    imageBlendMode: 'normal',
                    imageSecondaryBlendMode: '',
                    imageBlendColor: 'rgba(0,0,0,.3)',
                    imageSecondaryBlendColor: '',
                    presetImageFilters: '',
                    imageTextColor: '#FFF',
                    postImageTextSize: 13,
                    imagePostLineClamp: true,
                    imagePostLineClampValue: 3,
                    imagePostHideText: false,
                    imageFaceDetection: false,
                    hashtagTextColor: '',
                    hashtagBackgroundColor: '',
                    mentionTextColor: '',
                    mentionBackgroundColor: '',
                    urlTextColor: '',
                    urlBackgroundColor: '',
                    showTextEntityUrls: false,
                    showEngagementMetrics: false,
                    engagementMetricsSize: 30,
                    engagementMetricsPosition: 'bottom_left',
                    adsMetricsSize: 30,
                    showTextStyles: false,
                    showText: true,
                    textOnlyColor: '#FFF',
                    postTextOnlySize: 18,
                    postLineClamp: true,
                    postLineClampValue: 7,
                    textFitMin: 20,
                    showPostTextOverlay: false,
                    showUserGroup: true,
                    showUserAvatar: true,
                    showUserName: true,
                    showUserScreenName: true,
                    userGroupIconSize: 10,
                    userGroupAvatarSize: 20,
                    userGroupNameSize: 20,
                    userGroupScreenNameSize: 16,
                    userGroupPosition: 'top',
                    userGroupGradientColor: 'rgba(0,0,0,.3)',
                    userGroupGradientEnabled: false,
                    userGroupGradientDirection: 'bottomToTop',
                    showTimeStamp: false,
                    timeStampSize: 15,
                    timeStampFormat: 'timeAgo',
                    endianTime: 'D MMM YYYY, h:mm a',
                    textOnlyBackgroundColor: '',
                    textOnlyTextFormat: 'clamp',
                    textOnlyTeleprompterSpeed: 50,
                    postImageTextFormat: 'clamp',
                    postImageTeleprompterSpeed: 50,
                    imageBackgroundSize: 'cover',
                    showZeroEngagementValues: false,
                    maxCharacters: 180,
                    teleprompterSpeed: 50,
                    userGroupLayoutType: 'a',
                    postCompositionType: 'a',
                    socialIconBgColor: false,
                    customFields: {
                        fieldId: '',
                        size: 12,
                    },
                    reviews: {
                        enabled: false,
                        title: {
                            enabled: true,
                            color: '',
                            size: 17,
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 2,
                                },
                                fit: {
                                    min: 10,
                                    max: 400,
                                },
                            },
                        },
                        rating: {
                            enabled: true,
                            filledColor: '',
                            emptyColor: '',
                            size: 12,
                        },
                        product: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                        message: {
                            enabled: true,
                            size: 13,
                            color: '',
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 5,
                                },
                                fit: {
                                    min: 20,
                                    max: 400,
                                },
                            },
                        },
                        domain: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                    },
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    postComposition: 'a',
                    extraPostDataOptions: {
                        enabled: true,
                        color: '',
                        size: '32',
                        value: {
                            format: '1.23k',
                        },
                        border: {
                            enabled: true,
                            color: '',
                        },
                        header: {
                            enabled: true,
                            size: '50',
                            text: 'Additional Details',
                            color: '',
                        },
                    },
                    gridLayout: {
                        gap: 10,
                        columns: 1,
                    },
                    classes: 'rel',
                    nativeStyling: {
                        enabled: true,
                        lineClamp: {
                            enabled: true,
                            lines: 8,
                        },
                        maxCharacters: 400,
                        border: {
                            enabled: false,
                            color: 'rgba(0,0,0, .3)',
                            size: 5,
                        },
                        shadow: {
                            enabled: false,
                            color: 'rgba(0,0,0, .2)',
                            size: 15,
                        },
                        fontScale: 30,
                    },
                    postTemplate: 'card',
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                    smartSizeCompositions: {
                        baseline: {
                            postTextOnlySize: 18,
                            postImageTextSize: 13,
                            engagementMetricsSize: 15,
                            userGroupIconSize: 10,
                            userGroupAvatarSize: 18,
                            userGroupNameSize: 13,
                            userGroupScreenNameSize: 10,
                            extraPostDataOptions: {
                                size: 50,
                                header: {
                                    size: 60,
                                    enabled: true,
                                },
                            },
                        },
                        optionDefaults: {
                            postLineClampValue: 7,
                            imagePostLineClampValue: 3,
                            extraPostDataOptions: {
                                header: {
                                    enabled: true,
                                },
                            },
                            classOverrides: {
                                userGroup: {
                                    default: 'p-reset p-0 pb-1',
                                },
                                postText: {
                                    default: 'p-reset p-0 pt-1',
                                },
                                metaGroup: {
                                    default: 'p-reset p-0 pt-1',
                                },
                                lineClampVerticalAlign: {
                                    default: 'top',
                                },
                                extraPostData: {
                                    default: 'p-reset p-0 pt-1',
                                },
                                postInner: {
                                    default: 'p-reset p-2',
                                },
                            },
                        },
                        breakpoints: {
                            xs: {
                                options: {
                                    postLineClampValue: 3,
                                    imagePostLineClampValue: 2,
                                    extraPostDataOptions: {
                                        header: {
                                            enabled: false,
                                        },
                                    },
                                    classOverrides: {
                                        userGroup: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        postText: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        metaGroup: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        lineClampVerticalAlign: {
                                            default: 'top',
                                        },
                                        extraPostData: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        postInner: {
                                            default: 'p-reset p-05',
                                        },
                                    },
                                },
                            },
                            s: {
                                options: {
                                    postLineClampValue: 4,
                                    imagePostLineClampValue: 2,
                                    extraPostDataOptions: {
                                        header: {
                                            enabled: false,
                                        },
                                    },
                                    classOverrides: {
                                        userGroup: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        postText: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        metaGroup: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        lineClampVerticalAlign: {
                                            default: 'top',
                                        },
                                        extraPostData: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        postInner: {
                                            default: 'p-reset p-05',
                                        },
                                    },
                                },
                            },
                            m: {
                                options: {
                                    postLineClampValue: 4,
                                    imagePostLineClampValue: 3,
                                    extraPostDataOptions: {
                                        header: {
                                            enabled: false,
                                        },
                                    },
                                    classOverrides: {
                                        userGroup: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        postText: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        metaGroup: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        lineClampVerticalAlign: {
                                            default: 'top',
                                        },
                                        extraPostData: {
                                            default: 'p-reset p-0 pb-05',
                                        },
                                        postInner: {
                                            default: 'p-reset p-05',
                                        },
                                    },
                                },
                            },
                            ml: {
                                options: {
                                    classOverrides: {
                                        userGroup: {
                                            default: 'p-reset p-0 pb-1',
                                        },
                                        postText: {
                                            default: 'p-reset p-0 pt-1',
                                        },
                                        metaGroup: {
                                            default: 'p-reset p-0 pt-1',
                                        },
                                        lineClampVerticalAlign: {
                                            default: 'top',
                                        },
                                        extraPostData: {
                                            default: 'p-reset p-0 pt-1',
                                        },
                                        postInner: {
                                            default: 'p-reset p-1',
                                        },
                                    },
                                },
                            },
                            l: {
                                options: {
                                    classOverrides: {
                                        userGroup: {
                                            default: 'p-reset p-0 pb-1',
                                        },
                                        postText: {
                                            default: 'p-reset p-0 pt-1',
                                        },
                                        metaGroup: {
                                            default: 'p-reset p-0 pt-1',
                                        },
                                        lineClampVerticalAlign: {
                                            default: 'top',
                                        },
                                        extraPostData: {
                                            default: 'p-reset p-0 pt-1',
                                        },
                                        postInner: {
                                            default: 'p-reset p-1',
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
                userAssetContentUrl: null,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                id: {
                                    columnType: null,
                                    columnId: null,
                                    reportingEngine: 'CAMPAIGN',
                                    report: 'SPRINKSIGHTS',
                                    projections: [
                                        {
                                            measurementName: 'CAMPAIGN_ID',
                                            heading: 'Campaign',
                                            aggregateFunction: 'SUM',
                                            details: {
                                                alternateHeading: '',
                                            },
                                        },
                                        {
                                            measurementName: 'OUTBOUND_STATUS',
                                            heading: 'Status',
                                            aggregateFunction: 'SUM',
                                            details: {
                                                alternateHeading: '',
                                            },
                                        },
                                        {
                                            heading: 'Account',
                                            measurementName: 'ACCOUNT_ID',
                                            aggregateFunction: 'SUM',
                                            details: {
                                                origReport: 'CAMPAIGN',
                                            },
                                        },
                                        {
                                            heading: 'Channel',
                                            measurementName: 'SN_TYPE',
                                            aggregateFunction: 'SUM',
                                            details: {
                                                origReport: 'CAMPAIGN',
                                            },
                                        },
                                    ],
                                    sorts: [
                                        {
                                            order: 'DESC',
                                            heading: 'SCHEDULE_DATE',
                                        },
                                    ],
                                    filters: [],
                                    timePeriods: null,
                                    source: 'CAMPAIGN',
                                    pageSize: 60,
                                    groupBys: [
                                        {
                                            dimensionName: 'USER_ID',
                                            heading: 'USER_ID',
                                            groupType: 'FIELD',
                                        },
                                    ],
                                    timePeriod: {
                                        timeZone: 'America/Los_Angeles',
                                        key: 'last_7_days',
                                        duration: 1,
                                        startTime: 1571727600000,
                                        endTime: 1571813999999,
                                    },
                                    showInReplyToPost: false,
                                },
                                options: {
                                    count: 200,
                                    ordered: true,
                                    imagePreload: true,
                                    removeDuplicates: false,
                                    shufflePosts: false,
                                    includeFaceDetection: false,
                                },
                                data: [
                                    {
                                        messageType: 2,
                                        accountId: null,
                                        snMsgId: null,
                                        partnerId: null,
                                        clientId: 8033,
                                        sourceType: null,
                                        sourceId: null,
                                        snType: 'Twitter',
                                        snCreatedTime: 1571806800000,
                                        permalink: null,
                                        message:
                                            'Be ready for any storm! Stay updated with The National Oceanic and Atmospheric Administration. #NOAA',
                                        textEntities: null,
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'Austin, TX',
                                            gender: null,
                                            snId: '24314460',
                                            name: 'Jake Trigg',
                                            screenName: 'ATXatLarge',
                                            email: null,
                                            bio:
                                                "Product, Program and Project Manager for high-growth software startups. I'm a click-counter, and focus on empowering others and being of service.",
                                            following: 214,
                                            followers: 85,
                                            favCount: 37,
                                            statusCount: 534,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/ATXatLarge',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/1254840369/ATX_Large-logo_normal.png',
                                            createdTime: 1236999001000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5bc4be8ae4b03a19f57fb6bb',
                                            participationIndex: 0,
                                            influencerIndex: 38,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [281513],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: null,
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[0].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: 'MESSAGE_2465421005',
                                        scheduledTime: 1571806800000,
                                        status: 'DRAFT',
                                        accountIds: [255792],
                                        accountGroupIds: [],
                                        channelSpecificAdditionalProperties: [
                                            {
                                                data: {
                                                    KEEP_SQUARE_ASPECT_RATIO: ['false'],
                                                    INSTAGRAM_DIRECT_MEDIA_PUBLISH: ['true'],
                                                    dirty: ['true'],
                                                },
                                                channelInfo: {
                                                    channelType: 'INSTAGRAM',
                                                    accountType: null,
                                                    accountId: null,
                                                    contentType: 'POST',
                                                    locale: null,
                                                    templateId: '5b98aeebe4b0fb90b90769ff',
                                                    templateIndex: null,
                                                },
                                            },
                                            {
                                                data: {
                                                    USER_SELECTED_TIME_ZONE: ['America/New_York'],
                                                    USER_SELECTED_TIME_ZONE_COUNTRY: ['US'],
                                                    USE_ACCOUNT_TIMEZONE_FOR_PUBLISHING: ['false'],
                                                    CLIENT_REF: ['QUICK_PUBLISHER'],
                                                },
                                                channelInfo: {
                                                    channelType: 'OUTBOUND',
                                                    accountType: null,
                                                    accountId: null,
                                                    contentType: null,
                                                    locale: null,
                                                    templateId: null,
                                                    templateIndex: null,
                                                },
                                            },
                                        ],
                                        snStats: null,
                                        projectionStats: null,
                                        numberOfLikes: null,
                                        numberOfShares: null,
                                        numberOfComments: null,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: null,
                                        workflowProperties: {
                                            sentiment: null,
                                            partnerCustomProperties: {
                                                '5be31b2fe4b0a626418a79b8': [],
                                                spr_uc_priority: ['Medium'],
                                                spr_campaign_goal: ['Brand Awareness'],
                                                '5bd6c53ce4b0b0fc07356794': ['Public Libraries'],
                                                '5bd6c0c7e4b03983d4257313': ['Public Sector'],
                                                '5bd6c53ce4b0b0fc0735676f': ['Global'],
                                                '5be31591e4b099fb0e09b023': ['ACME'],
                                                '5bd888dfe4b027b53c170dd2': ['Not Started'],
                                            },
                                            clientCustomProperties: {},
                                            customProperties: null,
                                            campaignId: '8033_10',
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [
                                            {
                                                heading: 'Channel',
                                                value: 'Twitter',
                                            },
                                            {
                                                heading: 'Region',
                                                value: 'US',
                                            },
                                            {
                                                heading: 'Status',
                                                value: 'DRAFT',
                                            },
                                            {
                                                heading: 'Campaign',
                                                value: 'Big Reveal',
                                            },
                                        ],
                                        channelCustomProperties: null,
                                    },
                                ],
                            },
                        ],
                        format: {
                            type: 'buckets',
                            options: {
                                padding: 1,
                                buckets: {
                                    any: {
                                        filter: 'post.type',
                                    },
                                },
                                panels: [
                                    {
                                        total: 1,
                                        buckets: ['any', -1],
                                    },
                                ],
                            },
                        },
                        showInReplyToPost: false,
                    },
                ],
                classes: null,
                theme: {
                    colorFont: null,
                    colorPrimary: '',
                    colorSecondary: '#ff6060',
                    colorBackground: '',
                    colorNegative: '',
                    colorPostive: '',
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    fontFamilyPrimary: '',
                    fontFamilySecondary: '',
                    fontSizePrimary: '',
                    fontSizeSecondary: null,
                    fontPrimary: null,
                    fontSecondary: null,
                    backgroundImage: {
                        url: '',
                        previewUrl: null,
                        samId: null,
                        name: null,
                        description: null,
                        backgroundRepeat: null,
                        backgroundSize: null,
                    },
                    typography: {
                        color: '',
                        size: null,
                        sizeLiteral: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        solid: '',
                        highlight: null,
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        ranked: {
                            colors: null,
                            contrast: null,
                        },
                    },
                },
                position: {
                    left: '2.08%',
                    right: null,
                    top: '3.72%',
                    bottom: null,
                    width: '95.84%',
                    height: '92.56%',
                    portrait: {
                        left: '3%',
                        top: '2%',
                        width: '94%',
                        height: '96%',
                    },
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                analyticsRequests: null,
                analyticsResults: null,
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Run of Show',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 20,
                },
            },
        ],
        id: '1',
        name: null,
        type: null,
        css: null,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            labelTimeZone: '',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: true,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_post_card',
        theme: {
            colorFont: null,
            colorPrimary: null,
            colorSecondary: null,
            colorBackground: null,
            colorNegative: null,
            colorPostive: null,
            ext: {
                padding: 0,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            fontFamilyPrimary: null,
            fontFamilySecondary: null,
            fontSizePrimary: null,
            fontSizeSecondary: null,
            fontPrimary: null,
            fontSecondary: null,
            backgroundImage: null,
            typography: {
                color: '',
                size: null,
                sizeLiteral: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                solid: '',
                highlight: null,
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                ranked: {
                    colors: null,
                    contrast: null,
                },
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Header',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1571786142763,
};
export default runOfShowSnapshot;
